import { Injectable } from '@angular/core';
import {BehaviorSubject, combineLatest, Subscription} from 'rxjs';
import { getMenuData, MenuDataItem } from './config';
import { DeveloperService } from '../developer/developer.service';
import {map} from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class MenuService{
	private subscription = new Subscription();
	private menuData: MenuDataItem[];
	private _menuData$: BehaviorSubject<MenuDataItem[]> = new BehaviorSubject<MenuDataItem[]>([]);
	private _title: string;
	private _title$: BehaviorSubject<string> = new BehaviorSubject<string>('');
	private devModeCategory: MenuDataItem[] = [{
		category: true,
		title: 'Unsere Seiten',
		permissions: []
	},
	{
		title: 'Hardwarespielwiese',
		key: 'hardwarespielweise',
		icon: 'grid',
		url: '/io/hardwarespielwiese',
		permissions: []
	}];
	private demoModeCategory: MenuDataItem[] = [{
		category: true,
		title: 'Demonstration',
		permissions: []
	},
	{
		title: 'UI-Showcase',
		key: 'ui-showcase',
		icon: 'layout',
		url: '/ui-showcase',
		permissions: []
	}];

	constructor(private developerService: DeveloperService) {
		const menuObserver = combineLatest([
			this.developerService.isDevMode$,
			this.developerService.isDemoMode$,
		]).pipe(
			map(([devMode, demoMode]) => {
				this.menuData = getMenuData;
				if (devMode) {
					this.menuData = this.menuData.concat(this.devModeCategory);
				}
				if (demoMode) {
					this.menuData = this.menuData.concat(this.demoModeCategory);
				}
				return this.menuData;
			})
		);
		this.subscription.add(menuObserver.subscribe((menuData) => this._menuData$.next(menuData)));
	}

	get menuData$(): BehaviorSubject<MenuDataItem[]> {
		return this._menuData$;
	}

	get title$(): BehaviorSubject<string> {
		return this._title$;
	}

	get title(): string {
		return this._title;
	}

	set title(title: string) {
		this._title = title;
		this._title$.next(title);
	}
}
